/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type ValidatePayoutBodyMethod = typeof ValidatePayoutBodyMethod[keyof typeof ValidatePayoutBodyMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidatePayoutBodyMethod = {
  UNIONPAY: 'UNIONPAY',
  ALIPAY: 'ALIPAY',
} as const;
